import { decode as base64_decode, encode as base64_encode } from 'base-64';
import RootStore from './RootStore';
import { postApi, baseURL } from '../components/Utility'
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
} from 'mobx';
import config from "../config";
import { message } from "antd";


class MileageReportStore {
  mileageReportStore = []
  loading = false
  total = 0
  rootStore

  constructor(rootStore) {
    makeObservable(this, {
      mileageReportStore: observable,
      loading: observable,
      total: observable,
      loadData: action
    });
    this.rootStore = rootStore;

  }



  async loadData({ companyId, vehicleId, offset, limit, fromDate, toDate, mileage, fuelprice, filterValue, pageNo }) {

    this.loading = true;
    var postData = { "companyId": companyId, "vehicleId": vehicleId, "mileage": mileage, "fuelprice": fuelprice, "fromDate": fromDate, "toDate": toDate, "offset": offset, "limit": limit, "filterValue": filterValue, "page": pageNo }

    if (config.pythonReport === 1) {
     
      var response = await postApi.getClient('report').post("/tracking_report/mileagereport", postData);
      
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi.getClient().post("index.php?c=vehicle&a=mileagereport", "postData=" + base64Input);
      
    }

    this.total = parseInt(response?.data?.data?.TotalCount);
    this.mileageReportStore = response?.data?.data?.mileagereport
    this.loading = false;
  }


  async exportExcel(getData) {

    if (config.pythonReport === 1) {

      getData = { ...getData, language: "english" }
      
      try {
          var response = await postApi.getClient("report").post("/tracking_report/mileagereport/download/excel", getData, {
              responseType: "blob",
          });
      
          const blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
      
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Mileage Report.xlsx";
      
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
    
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }

    } else {
      // console.log("getData", getData);
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportmileageexcel&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&mileage=" +
        getData.mileage +
        "&price=" +
        getData.fuelprice +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }

  }

  async exportpdf(getData) {

    if (config.pythonReport === 1) {

      getData = { ...getData, language: "english" }
      try {
            var response = await postApi.getClient().post("/tracking_report/mileagereport/download/pdf", getData, {
                responseType: "blob",
            });
        
            const blob = new Blob([response.data], {
                type: 'application/pdf'
            });
        
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Mileage Report.pdf";
        
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }

    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportmileagepdf&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        // "&int="+
        // getData.interval+
        "&mileage=" +
        getData.mileage +
        "&price=" +
        getData.fuelprice +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }

  }

  async exportcsv(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportmileagecsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      // "&int="+
      // getData.interval+
      "&mileage=" +
      getData.mileage +
      "&price=" +
      getData.fuelprice +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
  async exportxml(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportmileagexml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      // "&int="+
      // getData.interval+
      "&mileage=" +
      getData.mileage +
      "&price=" +
      getData.fuelprice +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }

}

export default MileageReportStore;
